import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { PdpRespDetail } from './PdpRespDetail';
import { PdpSharedDetail } from '../PdpSharedDetails/PdpSharedDetail';
import { detailsTitle } from '../messages/pdpDetailsMessages';

// helpers
import { slugify } from '../../utils/slugify';

// styles
import styles from './PdpRespDetails.scss';

const NUMBER_OF_COLUMNS = 4;
const detailsToHideInPrint = ['PRODUCTION_TIME'];

function PdpRespDetailsComponent(props) {
    const { item, currency } = props;
    const details = item.pdpDetailsDisplay;
    const numberOfRows = Math.ceil(details.length / NUMBER_OF_COLUMNS);

    return (
        <div className={styles.wrapper} data-tn="pdp-details">
            <h2 className={styles.header}>{detailsTitle}</h2>
            <div className="rowFlex">
                {details.reduce(
                    (detailComponents, detail, index) => {
                        const { detailKey, detailDisplayName, detailValues, delimiter } = detail;
                        const columnComponents = detailComponents[detailComponents.length - 1];
                        // exclude this from showing in print layout
                        const shouldHideInPrint = detailsToHideInPrint.includes(detailKey);
                        // Add detail to column
                        columnComponents.push(
                            <PdpRespDetail
                                delimiter={delimiter}
                                title={detailDisplayName}
                                dataTn={slugify(detailDisplayName)}
                                key={`${detailKey}-${index}`}
                                printHide={shouldHideInPrint}
                            >
                                <PdpSharedDetail
                                    detailValues={detailValues}
                                    currency={currency}
                                    delimiter={delimiter}
                                />
                            </PdpRespDetail>
                        );
                        // check if column is full
                        if (
                            columnComponents.length === numberOfRows ||
                            index === details.length - 1
                        ) {
                            // render columnComponents in column
                            detailComponents[detailComponents.length - 1] = (
                                <ul
                                    key={`column-${detailKey}-${index}`}
                                    className={`colXl3 colXs6 ${styles.column}`}
                                >
                                    {columnComponents}
                                </ul>
                            );
                            // if not the last detail, then initialize next column of details
                            if (index !== details.length - 1) {
                                detailComponents[detailComponents.length] = [];
                            }
                        }
                        return detailComponents;
                    },
                    [[]]
                )}
            </div>
        </div>
    );
}

PdpRespDetailsComponent.propTypes = {
    currency: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export const PdpRespDetails = createFragmentContainer(PdpRespDetailsComponent, {
    item: graphql`
        fragment PdpRespDetails_item on Item {
            pdpDetailsDisplay {
                detailKey
                delimiter
                detailDisplayName
                detailValues {
                    ...PdpSharedDetail_detailValues
                }
            }
        }
    `,
});
